import React from 'react'
import "./Hotel.css"
import { Link } from 'react-router-dom';

function Hotel({image,name,location,bookmytable,ratings,rates}) {
    return (
        <div className='hotel'>
            <img src={image} alt="This is an image"></img>
            <div className='hotel_details'>
            <h1 className='htl_name'>{name}</h1>
            <a className='location' href={location}>Location</a>
            <Link to={bookmytable}>
                <div className='book_table'>
                    <span>Book My Table</span>
                </div>
            </Link>
            <h4 className='ratings'>Rating</h4>
            <span className='rates'>{rates}</span>
            </div>
        </div>
    )
}

export default Hotel
